module.exports = __webpack_public_path__ + "static/img/cont210.20330db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont210.jpg
// module id = wbIR
// module chunks = 0